<template>
  <div class="user-card topup">
    <div class="topup-header">{{ $t('topUp') }}</div>
    <div class="topup-online">
      <instant v-if="$route.query.type"></instant>
      <online v-else></online>
    </div>
    <!--<div class="topup-tabs">-->
      <!--<md-tabs-->
        <!--v-model="activeName"-->
      <!--&gt;-->
        <!--<md-tab-pane name="online" :label="tabTitles[0]">-->
          <!--<div class="topup-online">-->
            <!--<instant v-if="$route.query.type"></instant>-->
            <!--<online v-else></online>-->
          <!--</div>-->
        <!--</md-tab-pane>-->
        <!--<md-tab-pane name="manual" :label="tabTitles[1]">-->
          <!--<manual-transfer></manual-transfer>-->
        <!--</md-tab-pane>-->
      <!--</md-tabs>-->
    <!--</div>-->
  </div>
</template>

<script>
import { Tabs, TabPane } from 'mand-mobile'
import Online from '@/components/user/topup/Online'
import Instant from '@/components/user/topup/Instant'
import ManualTransfer from '@/components/user/topup/ManualTransfer'

export default {
  i18n: {
    messages: {
      en: {
        topUp: 'Top up',
        online: 'VA(Instant)',
        manualTransfer: 'Manual Transfer',
      },
      id: {
        topUp: 'Penyaluran Dana',
        online: 'VA(Instant)',
        manualTransfer: 'Manual Transfer',
      },
    },
  },
  components: {
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    Online,
    Instant,
    ManualTransfer,
  },
  data() {
    return {
      tabTitles: [this.$t('online'), this.$t('manualTransfer')],
      activeName: 'online',
    }
  },
}
</script>

<style lang="stylus" scoped>
.topup {
  padding: 20px 0;
}

.topup-header {
  padding: 0 20px;
  margin: 8px 0 14px;
  font-weight: bold;
  font-size: 24px;
}

.topup-tabs /deep/ {
  .md-tab-bar {
    .md-tab-titles-wrapper {
      .md-tab-title {
        color: #101010;
        &.active {
          color: color-primary;
        }
      }
    }
  }
}
</style>
